<div class="blogs__details">
    <div class="blogs__details-container">
        <div class="blogs__details-info">
            <img class="blogs__details-img" [src]="blog.url" alt="blog-img">
            <div class="blogs__details-details">
                <div [innerHTML]="blog.description" l10nTranslate></div>
            </div>
        </div>
    </div>
    <div class="blogs__details-more-blogs-container">
        <h2 class="blogs__details-more-blogs-title" l10nTranslate>More Blogs</h2>
        <div class="blogs__details-more-blogs-results">
            <ng-container *ngFor="let blog of blogs; let i = index">
                <div class="blogs__details-more-blogs-card" *ngIf="i<3">
                    <div class="blogs__details-more-blogs-card-info">
                        <img [src]="blog.url" alt="blog-img">
                        <div class="blogs__details-result-card-type">
                            <span class="blogs__details-result-card-type-news" l10nTranslate>News</span>
                            <span class="blogs__details-result-card-type-cybersecurity" l10nTranslate>Cybersecurity</span>
                        </div>
                        <div class="blogs__details-more-blogs-card-details">
                            <div class="blogs__details-more-blogs-card-title" l10nTranslate>{{blog.title}}</div>
                            <div class="blogs__details-more-blogs-card-Lorem">July 5 ,2023</div>
                            <button class="blogs__details-btn-read-more" (click)="blogDetailsNavigation(blog.id)" l10nTranslate>Read
                                more</button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <button class="blogs__details-btn-all-blogs" [routerLink]="['/blogs']" l10nTranslate>View All</button>
    </div>
</div>